import useFetch from 'use-http';

import { API_ROUTES } from '../../../constants';
import type {
  TAPIPostPutTechDetails,
  TBody,
} from './post-put-tech-details.hook.types';
import type { TTechDetailsResponse } from '../technical-details.types';

export const useAPIPostPutTechDetails = (): TAPIPostPutTechDetails => {
  const { post, put, error, loading, response, data } =
    useFetch<TTechDetailsResponse>(API_ROUTES.APPLICATIONS);

  async function postTechDetails({
    applicationId,
    body,
  }: TBody): Promise<TTechDetailsResponse['data']> {
    const data = await post(`${applicationId}/tech-details`, body);
    return data;
  }

  async function putTechDetails({
    applicationId,
    body,
  }: TBody): Promise<TTechDetailsResponse['data']> {
    const data = await put(`${applicationId}/tech-details`, body);
    return data;
  }

  return {
    data: data?.data || data,
    loading,
    error,
    loaded: response.ok,
    postTechDetails,
    putTechDetails,
  };
};
